import createContext from '~/components/context';
export const [DropdownProvider, useDropdownContext] = createContext('Dropdown');
//# sourceMappingURL=dropdown-context.js.map